import React from 'react';
import { 
  User, 
  Mail, 
  Calendar, 
  TrendingUp, 
  Users, 
  FileText, 
  AlertCircle, 
  Bell, 
  CheckCircle, 
  Clock, 
  Download, 
  Upload, 
  Activity, 
  DollarSign, 
  ShoppingCart, 
  Star,
  MessageCircle,
  FileCheck,
  UserCheck,
  Briefcase
} from 'lucide-react';

// Expanded color schemes
const colorSchemes = {
  blue: { text: 'text-blue-600', icon: 'text-blue-500' },
  green: { text: 'text-green-600', icon: 'text-green-500' },
  purple: { text: 'text-purple-600', icon: 'text-purple-500' },
  orange: { text: 'text-orange-600', icon: 'text-orange-500' },
  red: { text: 'text-red-600', icon: 'text-red-500' },
  indigo: { text: 'text-indigo-600', icon: 'text-indigo-500' },
  teal: { text: 'text-teal-600', icon: 'text-teal-500' },
  pink: { text: 'text-pink-600', icon: 'text-pink-500' },
  yellow: { text: 'text-yellow-600', icon: 'text-yellow-500' },
  cyan: { text: 'text-cyan-600', icon: 'text-cyan-500' }
};

// Expanded icon mapping
const iconComponents = {
  user: User,
  users: Users,
  mail: Mail,
  calendar: Calendar,
  trendingUp: TrendingUp,
  file: FileText,
  alert: AlertCircle,
  notification: Bell,
  completed: CheckCircle,
  pending: Clock,
  download: Download,
  upload: Upload,
  activity: Activity,
  revenue: DollarSign,
  orders: ShoppingCart,
  rating: Star,
  messages: MessageCircle,
  documents: FileCheck,
  activeUsers: UserCheck,
  projects: Briefcase
};

const DashboardCard = ({ 
  title, 
  value, 
  icon,
  colorScheme = 'blue',
  className = '',
  onClick // Add onClick handler
}) => {
  const IconComponent = iconComponents[icon];
  const colors = colorSchemes[colorScheme];

  return (
    <div 
      className={`bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow ${className}`}
      onClick={onClick} // Apply the onClick handler to the card
      style={{ cursor: 'pointer' }} // Optional: show a pointer cursor when hovering over the card
    >
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-gray-500 text-sm">{title}</h3>
          <p className={`text-2xl font-bold ${colors.text}`}>{value}</p>
        </div>
        {IconComponent && <IconComponent className={colors.icon} size={32} />}
      </div>
    </div>
  );
};

export default DashboardCard;
